export default __webpack_public_path__ + "static/font-175fb6e0b141370219fcc917e35f2176.woff";